import { Switch, useRouteMatch, Route } from 'react-router-dom';

import LeadBoard from './LeadBoard';
import AddLeadPage from 'modules/lead/AddLead/AddLeadPage';
import LeadDetails from 'modules/lead/LeadDetails/LeadDetails';
import OnlineLeadsList from 'modules/lead/LeadList/components/OnlineLeads/OnlineLeadsList';

function LeadRouterNew() {
  let { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={path} component={LeadBoard} />
      <Route exact path={`${path}/online`} component={OnlineLeadsList} />
      <Route exact path={`${path}/new/:id?`} component={AddLeadPage} />
      <Route path={`${path}/:id`} component={LeadDetails} />
    </Switch>
  );
}

export default LeadRouterNew;
